var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLampFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H9V19H11V16Z",
    fill: "#CA3C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8H0V10H3V8Z",
    fill: "#CA3C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H17V10H20V8Z",
    fill: "#CA3C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3012 13.3943L13.8941 14.8014L16.0154 16.9227L17.4225 15.5156L15.3012 13.3943Z",
    fill: "#CA3C3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70547 13.3872L2.58417 15.5085L3.9913 16.9156L6.1126 14.7943L4.70547 13.3872Z",
    fill: "#CA3C3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.02V0H7V5.02C5.79 5.94 5 7.37 5 9C5 11.76 7.24 14 10 14C12.76 14 15 11.76 15 9C15 7.37 14.21 5.94 13 5.02ZM9 2H11V4.1C10.68 4.04 10.34 4 10 4C9.66 4 9.32 4.04 9 4.1V2Z",
    fill: "#CA3C3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampFailure);
export default __webpack_public_path__ + "static/media/lamp_failure.37370d5bd9e0449e11ae1d9348d9cc4d.svg";
export { ForwardRef as ReactComponent };